import { ProductOrBrand } from "./alternativeTypes";

export const clothingProducts: ProductOrBrand[] = [
  {
    name: "Levi's",
    ownerCountry: "US",
    categories: ["clothing", "jeans"],
  },
  {
    name: "Nike",
    ownerCountry: "US",
    categories: ["clothing", "athletic"],
  },
  {
    name: "Gant",
    ownerCountry: "US",
    categories: ["clothing", "clothes"],
  },
  {
    name: "Calvin Klein",
    ownerCountry: "US",
    categories: ["clothing", "clothes", "jeans"],
  },
  {
    name: "Ralph Lauren",
    ownerCountry: "US",
    categories: ["clothing", "clothes"],
  },
  {
    name: "Tommy Hilfiger",
    ownerCountry: "US",
    categories: ["clothing", "clothes"],
  },
  {
    name: "Michael Kors",
    ownerCountry: "US",
    categories: ["clothing", "clothes"],
  },
  {
    name: "UGG",
    ownerCountry: "US",
    categories: ["clothing", "shoes"],
  },
  {
    name: "Vans",
    ownerCountry: "US",
    categories: ["clothing", "shoes"],
  },
  {
    name: "Asket",
    ownerCountry: "SE",
    notAvailableIn: ["CA"],
    categories: ["clothing", "jeans"],
    sourceLinks: ["https://www.asket.com/"],
  },
  {
    name: "Adidas",
    ownerCountry: "DE",
    categories: ["clothing", "athletic"],
    sourceLinks: [
      "https://www.adidas.com",
      "https://en.wikipedia.org/wiki/Adidas",
    ],
  },
  {
    name: "Armor-Lux",
    ownerCountry: "FR",
    availableIn: ["FR"],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://fr.wikipedia.org/wiki/Armor-Lux"
    ],
  },
  {
    name: "Eden Park",
    ownerCountry: "FR",
    availableIn: ["FR", "BE", "CA", "ES", "IE", "IT", "LU", "UK", "CZ", "CH"],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://stores.eden-park.com/fr_fr/vetements/",
      "https://fr.wikipedia.org/wiki/Eden_Park_(marque)"
    ],
  },
  {
    name: "Jack & Jones",
    ownerCountry: "DK",
    availableIn: [
      "DK", "DE", "NL", "ES", "FR", "BE",
      "CH", "IT", "NO", "SE", "FI", "AT",
      "UK", "IE", "PL", "PT", "CA", "LU",
      "GR", "LT", "CZ", "EE", "LV", "SI",
      "AL",
    ],
    categories: ["clothing", "clothes", "jeans"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Bestseller_(company)",
      "https://www.jackjones.com/",
    ],
  },
  {
    name: "ONLY",
    ownerCountry: "DK",
    availableIn: [
      "AT", "BE", "DK", "CZ", "FI", "FR",
      "DE", "GR", "IE", "IT", "LU", "NL",
      "NO", "PL", "PT", "ES", "SE", "CH",
      "UK"
    ],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Bestseller_(company)",
      "https://www.only.com/",
    ],
  },
  {
    name: "H&M",
    ownerCountry: "SE",
    categories: ["clothing", "clothes", "jeans"],
    sourceLinks: ["https://en.wikipedia.org/wiki/H%26M", "https://www.hm.com/"],
  },
  {
    name: "Ganni",
    ownerCountry: "DK",
    availableIn: [
      "AU", "AT", "BE", "BG", "CA", "HR",
      "CZ", "DK", "EE", "FI", "FR", "DE",
      "GR", "IE", "IT", "LV", "LT", "LU",
      "NL", "NO", "PL", "PT", "RO", "SI",
      "ES", "SE", "CH", "UK",
    ],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Ganni",
      "https://www.ganni.com/",
    ],
  },
  {
    name: "Superdry",
    ownerCountry: "UK",
    headquarterIn: "UK",
    availableIn: ["UK", "FR", "DE", "ES", "IT", "NL", "BE", "SE", "NO", "DK", "FI", "IE"],
    comments: "British fashion retailer known for combining vintage American styles with Japanese-inspired graphics. Founded in 2003, Superdry offers clothing, accessories, and footwear.",
    categories: ["clothing", "clothes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Superdry", "https://corporate.superdry.com/about-superdry/our-history/"]
  },
  {
    name: "Moncler",
    ownerCountry: "IT",
    availableIn: [
      "AU", "AT", "BE", "BG", "CA", "HR",
      "CZ", "DK", "EE", "FI", "FR", "DE",
      "GR", "IE", "IT", "LV", "LT", "LU",
      "NL", "NO", "PL", "PT", "RO", "SI",
      "ES", "SE", "CH", "UK",
    ],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Moncler",
      "https://www.moncler.com/",
    ],
  },
  {
    name: "C&A",
    ownerCountry: "CH",
    headquarterIn: "DE",
    availableIn: [
      "DE", "BE", "CH", "HR", "ES", "CZ", "FR", "IT"
    ],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/C%26A"
    ],
  },
  {
    name: "Louis Vuitton",
    ownerCountry: "FR",
    availableIn: [
      "CA", "MX", "AU", "BE", "DK", "DE",
      "ES", "FI", "FR", "IE", "IT", "LU",
      "NL", "AT", "SE", "UK",
    ],
    include: false,
    categories: ["clothing"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Louis_Vuitton",
      "  https://www.louisvuitton.com/",
    ],
  },
  {
    name: "Gucci",
    ownerCountry: "FR",
    headquarterIn: "IT",
    include: false,
    categories: ["clothing"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Kering"
    ],
  },
  {
    name: "Zara",
    ownerCountry: "ES",
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Zara_(retailer)",
      "https://www.zara.com/",
    ],
  },
  {
    name: "Zeeman",
    ownerCountry: "NL",
    availableIn: ["BE", "FR", "DE", "LU", "NL", "ES", "PT"],
    categories: ["clothing", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Zeeman_(store)",
      "http://zeeman.com/",
    ],
  },
  { 
    name: "New Rock", 
    ownerCountry: "ES", 
    headquarterIn: "ES", 
    availableIn: ["AL", "AM", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR","DE", "GR", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "MD", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SI", "ES", "SE", "CH", "TR", "UA", "UK"], 
    comments: "Spanish shoe and clothing company known for goth-style boots, shoes, and apparel.", 
    categories: ["clothing", "shoes", "clothes"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/New_Rock"] 
  },  
  {
    name: "Solovair",
    ownerCountry: "UK",
    availableIn: ["UK"],
    categories: ["clothing", "shoes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Solovair",
    ],
  },
  {
    name: "Varusteleka",
    ownerCountry: "FI",
    categories: ["clothing", "clothes"],
    availableIn: ["FI"],
    sourceLinks: ["https://www.varusteleka.com/en"],
  },
  {
    name: "Kenzo",
    ownerCountry: "FR",
    availableIn: [
      "AU", "AT", "BE", "BG", "CA",
      "HR", "CZ", "DK", "EE", "FI",
      "FR", "DE", "GR", "IS", "IE",
      "IT", "LV", "LT", "LU", "MT",
      "MX", "NL", "NO", "PL", "PT",
      "RO", "SI", "ES", "SE", "CH",
      "UK",
    ],
    categories: ["clothing", "jeans", "clothes"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Kenzo_(brand)",
      "http://www.kenzo.com/",
    ],
  },
  {
    name: "Nudie",
    ownerCountry: "SE",
    availableIn: ["SE", "NO", "UK", "AU", "ES", "DE", "CH"],
    categories: ["clothing", "jeans"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Nudie_Jeans",
      "http://www.nudiejeans.com/",
    ],
  },
  {
    name: "Vessi",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["clothing", "shoes"],
    sourceLinks: [
      "https://ca.vessi.com",
    ],
  },
];